export enum InvoicePDFType {
  Download = 1,
  Email = 2,
}
